/**
 * Front page "Why Choose" industries slider: replaces the default
 * whychoose-slider.js behaviour with arrow stepping + 3s auto-advance.
 * Only applies to sections marked data-industries-autoslide.
 */
document.addEventListener('DOMContentLoaded', function () {
    var sections = document.querySelectorAll('.industries-section[data-industries-autoslide]');
    if (!sections.length) return;

    // Delay lets whychoose-slider.js init first; cloning the track then drops its listeners
    setTimeout(function () {
        sections.forEach(function (section) {
            var oldTrack = section.querySelector('.industries-slider__track');
            if (!oldTrack) return;

            var track = oldTrack.cloneNode(true);
            oldTrack.replaceWith(track);

            function cardWidth() {
                var card = track.querySelector('.industry-card');
                return card ? card.offsetWidth + parseInt(window.getComputedStyle(track).gap || 24, 10) : 0;
            }

            var prevBtn = section.querySelector('.slider-arrow--prev');
            var nextBtn = section.querySelector('.slider-arrow--next');
            if (prevBtn && nextBtn) {
                var newPrevBtn = prevBtn.cloneNode(true);
                var newNextBtn = nextBtn.cloneNode(true);
                prevBtn.replaceWith(newPrevBtn);
                nextBtn.replaceWith(newNextBtn);

                newNextBtn.addEventListener('click', function () {
                    track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
                });
                newPrevBtn.addEventListener('click', function () {
                    track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
                });
            }

            function advance() {
                if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 10) {
                    track.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
                }
            }

            var autoSlideInterval = setInterval(advance, 3000);
            section.addEventListener('mouseenter', function () { clearInterval(autoSlideInterval); });
            section.addEventListener('mouseleave', function () {
                clearInterval(autoSlideInterval);
                autoSlideInterval = setInterval(advance, 3000);
            });
        });
    }, 150);
});
